<template>
  <v-card class="mt-2 ml-2 mr-2">
    <v-tabs :vertical="$vuetify.breakpoint.mdAndUp" :centered="$vuetify.breakpoint.smAndDown" color="deep-purple accent-4" background-color="#F5F5FF5F">
      <v-tab  class="justify-md-start" disabled>
        <v-icon left>
          {{ firstTabIcon }}
        </v-icon>
        {{ firstTabTitle }}
      </v-tab>

      <v-tab class="justify-start" @click="tabInfrastructureTypeClick">
        INFRA TYPE
      </v-tab>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <p>
            </p>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <FInfrastructureTypeTable ref="refTabInfrastructureTypeClick"/>
          </v-card-text>
        </v-card>
      </v-tab-item>


    </v-tabs>

  </v-card>
</template>

<script>
import FInfrastructureTypeTable from "../../components/admin_infra/jenis/FInfrastructureTypeTable";

export default {
  name: "InfrastructureType",
  components: {
    FInfrastructureTypeTable
  },
  data() {
    return {
      firstTabTitle: 'INFRASTRUKTUR TYPE',
      firstTabIcon: ''
    }
  },
  methods: {
    tabUsersClick(){
      // this.$refs.refUsersTable.fetchParent()
    },
    tabInfrastructureTypeClick(){
      try {
        // this.$refs.refTabInfrastructureTypeClick.fetchParent()
      }catch (e) {
        e.toString()
      }
    },


  }
}
</script>

<style scoped>
</style>